import { Empty } from 'antd';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Empty
      image={icon ?? Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <div style={{ textAlign: 'center' }}>
          {title ? <div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div> : null}
          {description ? <div style={{ color: '#8c8c8c' }}>{description}</div> : null}
        </div>
      }
    >
      {action}
    </Empty>
  );
}
